module.exports = __webpack_public_path__ + "3b90f5a613d03de4ab6745412d338cb7.fbx";